import axios from "axios";
import { BE_ADDR } from "./host";

export const instance = axios.create({
    withCredentials: true,
    baseURL: BE_ADDR
})